import React from 'react'
import { auth } from './firebase-config';

function AccountDropdown() {

/* When the user clicks on the button,
toggle between hiding and showing the dropdown content */
function showOptions() {
    document.getElementById("myDropdown").classList.toggle("show");
  }
  
  // Close the dropdown menu if the user clicks outside of it
  window.onclick = function(event) {
    if (!event.target.matches('.dropbtn')) {
      var dropdowns = document.getElementsByClassName("dropdown-content");
      var i;
      for (i = 0; i < dropdowns.length; i++) {
        var openDropdown = dropdowns[i];
        if (openDropdown.classList.contains('show')) {
          openDropdown.classList.remove('show');
        }
      }
    }
  }

    return (
        <div className='dropdown'>
            <button class='btn-profile dropbtn' onClick={() => {showOptions()}}>{localStorage.user[0]}</button>
            <div id="myDropdown" class="dropdown-content">
                <a href="/Profile">Profile</a>
                <a href="/Settings">Account Settings</a>

            </div>
        </div>
    )
}

export default AccountDropdown
